var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "24px",
    viewBox: "0 0 13 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Uploads-Flow-+-New-Doc-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-381.000000, -1010.000000)",
    fill: "#3F3F3F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394,1027.13636 C394,1030.68182 391.045455,1033.63636 387.5,1033.63636 C383.954545,1033.63636 381,1030.68182 381,1027.13636 L381,1014.72727 C381,1012.12727 383.127273,1010 385.727273,1010 C388.327273,1010 390.454545,1012.12727 390.454545,1014.72727 L390.454545,1024.77273 C390.454545,1026.42727 389.154545,1027.72727 387.5,1027.72727 C385.845455,1027.72727 384.545455,1026.42727 384.545455,1024.77273 L384.545455,1015.90909 L386.318182,1015.90909 L386.318182,1024.77273 C386.318182,1025.48182 386.790909,1025.95455 387.5,1025.95455 C388.209091,1025.95455 388.681818,1025.48182 388.681818,1024.77273 L388.681818,1014.72727 C388.681818,1013.07273 387.381818,1011.77273 385.727273,1011.77273 C384.072727,1011.77273 382.772727,1013.07273 382.772727,1014.72727 L382.772727,1027.13636 C382.772727,1029.73636 384.9,1031.86364 387.5,1031.86364 C390.1,1031.86364 392.227273,1029.73636 392.227273,1027.13636 L392.227273,1015.90909 L394,1015.90909 L394,1027.13636 Z",
    id: "Page-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.52a596a3d9e18c85026bfd783bab195c.svg";
export { ForwardRef as ReactComponent };